import React from "react";

const Footer = () => {
  return (
    <section className="footer section-spacing-20 no-padding-bottom">
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <div className="section-content section-spacing-50">
              <div className="footer-menu flex">
                <div className="footer-brand">
                  <h4>NEXUS EVENTS</h4>
                  <p>
                    NEXUS EVENTS is Uganda's leading events planner and
                    production company with a vast experience in concerts &amp;
                    shows production, Dinner &amp; Staff Parties, Weddings,
                    Product Launches, Awards &amp; Auditions etc.
                  </p>
                  <p className="bold light-yellow">
                    +256 787 258 151, +256 393 810 810 <br /> Kiwatule-Mbogo
                    Road, At Nexus Lounge. <br />
                    info@nexuseventsug.com
                  </p>
                </div>
                <div className="footer-nav flex">
                  <div>
                    <h4>USEFUL LINKS</h4>
                    <ul>
                      <li>
                        <a href="/" target="_blank" rel="noopener noreferrer">
                          Home
                        </a>
                      </li>
                      <li>
                        <a
                          href="/about"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          About Us
                        </a>
                      </li>
                      <li>
                        <a
                          href="/contact"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Contact Us
                        </a>
                      </li>
                      <li>
                        <a
                          href="/services"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Our Services
                        </a>
                      </li>
                      <li>
                        <a
                          href="/portfolio"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Our Portfolio
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div>
                    <h4>SOCIAL MEDIA</h4>
                    <ul>
                      <li>
                        <a
                          href="https://x.com/nexusevents_ug"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          X/Twitter
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://facebook.com/nexuseventsug"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Facebook
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://instagram.com/nexusevents_ug"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Instagram
                        </a>
                      </li>
                      <li>
                        <a href="#" target="_blank" rel="noopener noreferrer">
                          Tiktok
                        </a>
                      </li>
                      <li>
                        <a href="#" target="_blank" rel="noopener noreferrer">
                          Youtube
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div>
                    <h4>COMPANY</h4>
                    <ul>
                      <li>
                        <a
                          href="https://webmail.nexuseventsug.com/webmail"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Webmail
                        </a>
                      </li>
                      <li>
                        <a href="#" target="_blank" rel="noopener noreferrer">
                          Events Policy
                        </a>
                      </li>
                      <li>
                        <a href="#" target="_blank" rel="noopener noreferrer">
                          Safety Policy
                        </a>
                      </li>
                      <li>
                        <a href="#" target="_blank" rel="noopener noreferrer">
                          Privacy Policy
                        </a>
                      </li>
                      <li>
                        <a href="#" target="_blank" rel="noopener noreferrer">
                          Other Resources
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="copyright padding-top-20 padding-bottom-8 center white">
              <p>&copy; 2025 NEXUS EVENTS UGANDA LTD, All Rights Reserved</p>
            </div>
            <div className="designer solid-yellow-top-border section-spacing-10 uppercase">
              <div className="design-inner center">
                <p className=" rich-small white">
                  Website by{" "}
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://ntuna.com"
                    className="yellow"
                  >
                    NTUNA.COM
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Footer;
